<template>
  <v-container mt-7>
    <v-form 
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col class="selectorColumn">
          <v-select
            v-model="insChoice"
            :items="insurances"
            item-text="Insurance"
            required
            :rules="[this.insChoice.length !== 0 || 'Insurance is required']"
            return-object
            :menu-props="{ maxHeight: '400' }"
            label="Insurance"
            outlined
            dense
            clearable
            @click:clear="$nextTick(() => (insChoice = []))"
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                label="Date"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="endDate" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>  
          <v-select
            v-model="dateRange"
            :items="dateRanges"
            item-text="Insurance"
            required
            :rules="[this.dateRange.length !== 0 || 'Range is required']"
            return-object
            :menu-props="{ maxHeight: '400' }"
            label="Date Range"
            outlined
            dense
            clearable
            @click:clear="$nextTick(() => (insChoice = []))"
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
            <v-btn 
              @click="validate"
              color="secondary"
              depressed
              block
              class="py-5"
            >
              Run Report
              <v-icon>mdi-play</v-icon>
            </v-btn>
          </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-col v-if="load" cols="12" class="text-center">
        <v-progress-circular
          color="secondary"
          indeterminate
          :size="50"
          :width="3"
        ></v-progress-circular>
      </v-col>
      
      <v-col
        v-else-if="insChoice.length === 0 && !showReport"
        cols="12"
      >
        <v-alert :value="true" type="info">
          Please select an insurance to continue
        </v-alert>
      </v-col>

      <v-col
        v-else-if="insChoice.length > 0 && !showReport"
        cols="12"
      >
        <v-alert :value="true" type="info">
          Press run report to continue
        </v-alert>
      </v-col>

      <v-col v-else-if="reportData.length === 0 && showReport" cols="12">
        <v-alert :value="true" type="info">
          There is no data available for this selection. Please change your
          filter selections and run report again
        </v-alert>
      </v-col>

      <v-col
        v-else-if="showReport && changeDetected && reportData.length > 0"
        cols="12"
      >
        <v-alert :value="true" type="info">
          Change detected: Run the report to see updated data
        </v-alert>
      </v-col>

      <v-col v-show="reportData.length > 0 && showReport">
        <MainNotifications
          :notificationsData="reportData ? reportData : null"
          :recordsPerPage="20"
        ></MainNotifications>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import MainNotifications from '../components/notificationsComponents/MainNotifications';

Vue.component('MainNotifications', MainNotifications);

export default {
  name: 'App',
  components: {
    MainNotifications,
  },
  data: () => ({
    user: [],
    insurances: [],
    insChoice: [],
    startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
      .toISOString()
      .substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    reportData: [],
    load: false,
    group: [],
    newNotifications: false,
    valid: true,
    showReport: false,
    changeDetected: false,
    dateRange:'',
    dateRanges:['1 month prior','3 months prior','6 months prior']
  }),
  mounted() {
    this.getUser();
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.getNotifications();
      }
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
        })
        .catch(err => this.$router.push('/login'));
      this.getInsurances();
    },
    async getInsurances() {
      const response = await axios.get('api/list/insurances').then((response) => {
        if (this.user.role === 'Admin' || this.user.role === 'Superuser') {
          this.insurances = response.data;
          this.insurances.unshift('All Insurances');
          this.insChoice = [];
        } else {
          this.insurances = this.user.insurance;
          this.insChoice = this.user.insurance;
        }
        this.getGroups();
      });
    },
    async getGroups() {
      if (
        this.user.role === 'Provider'
        || this.user.role === 'Group'
        || this.user.role === 'Clinical'
      ) {
        this.group = [];
        const response = await axios
          .get(`api/${this.user.insurance}/selection/${this.user.group}`)
          .then((response) => {
            const { data } = response;
            data.forEach((group) => {
              if (this.group.indexOf(group.Center_PCP_Number) === -1) {
                this.group.push(group.Center_PCP_Number);
              }
            });
          });
      }
      this.checkNew();
      setInterval(() => {
        this.checkNew();
      }, 300000);
    },
    async checkNew() {
      let url;
      if (this.user.role === 'Admin' || this.user.role === 'Superuser') {
        url = 'api/notifications/count';
      } else {
        url = `api/notifications/${this.insChoice}/${this.group}/count`;
      }
      const response = await axios.get(url).then((res) => {
        if (
          localStorage.getItem('count') < JSON.stringify(res.data.count)
          || this.newNotifications === true
        ) {
          localStorage.setItem('count', JSON.stringify(res.data.count));
          this.newNotifications = true;
        } else {
          this.newNotifications = false;
        }
      });
    },
    async getNotifications() {
      this.load = true;
      this.showReport = true;
      this.changeDetected= false;
      this.reportData = [];
      let ins;

      if(this.insChoice === 'All Insurances') {
        ins = 'all';
      } else {
        ins = this.insChoice;
      }
      const { group } = this;
      const { startDate } = this;
      const { endDate } = this;

      await axios
        .get(`api/notifications/main/${ins}/groups=${group}/provs=/locs=/${startDate}/${endDate}/undefined`)
        .then((response) => {
          this.reportData = response.data;
          this.load = false;
        })
    }
  },
  watch: {
    insChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    startDate() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    endDate() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    dateRange(){
      if(this.dateRange === '1 month prior'){
        this.startDate = new Date(new Date(this.endDate).getFullYear(), new Date(this.endDate).getMonth() - 1,  new Date(this.endDate).getDate())
          .toISOString()
          .substr(0, 10)
      } else if(this.dateRange === '3 months prior'){
        this.startDate = new Date(new Date(this.endDate).getFullYear(), new Date(this.endDate).getMonth() - 3,  new Date(this.endDate).getDate())
          .toISOString()
          .substr(0, 10)
      } else if(this.dateRange === '6 months prior'){
        this.startDate = new Date(new Date(this.endDate).getFullYear(), new Date(this.endDate).getMonth() - 6,  new Date(this.endDate).getDate())
          .toISOString()
          .substr(0, 10)
      }
    }
  }
};
</script>
